module.exports = __webpack_public_path__ + "img/16d001-41.e05bc135.png";